<template>
  <div style="height: 100%;width:100%;">
    <terminal-view v-if="gatewayCode"
                   ref="terminalView"
                   style="height:100%;width: 100%;"
                   :selectGateway="gatewayCode"
                   :getToken="getToken"
                   :userName="userName"
                   :baseUrl="baseUrl"
                   :container="'main-page'"
                   :hardwareType="this.gateway.hardwareType"
    ></terminal-view>
  </div>

</template>

<script >
import Vue from 'vue'
import TerminalView from "@/views/console/terminal/component/TerminalView.vue";
import { getToken, getUserInfo } from "@/utils/auth";
const BASE_URL = window.TERMINAL_URL;

export default Vue.extend({
  components: {
    TerminalView
  },
  props: {
    gateway:{
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      getToken : getToken(),
      userName : getUserInfo().user_name,
      baseUrl : BASE_URL,
    }
  },
  computed: {
    gatewayCode(){
      return this.gateway?.code || ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.terminalView.init();
    });
  },
  created() {

  },
  destroyed() {
  },
  methods: {

  },
  watch:{
    gatewayCode(){
      this.$nextTick(() => {
        this.$refs.terminalView.init();
      });
    }
  }
})
</script>

<style lang="less" scoped>

</style>
